/**
 * 设置相关 API 服务
 */
import { apiService } from '@shared/services/api/ApiService';
import { 
  GetAIAvatarPresetsResponse,
  GetAIAvatarResponse,
  SelectAIAvatarRequest, 
  SelectAIAvatarResponse,
  AIAvatarPreset
} from '@shared/types/api';

export class SettingsService {
  /**
   * 获取 AI 头像预设列表
   */
  static async getAIAvatarPresets() {
    const response = await apiService.get<any>('/avatar/ai/presets');
    if (!response.success || !response.data) {
      throw new Error((response as any).message || response.error?.message || 'Failed to get AI avatar presets');
    }
    return response.data;
  }

  /**
   * 获取用户的 AI 头像
   */
  static async getAIAvatar(model: 'gemini' | 'deepseek') {
    const response = await apiService.get<any>(`/avatar/ai/${model}`);
    if (!response.success || !response.data) {
      throw new Error((response as any).message || response.error?.message || 'Failed to get AI avatar');
    }
    return response.data;
  }

  /**
   * 选择 AI 头像预设
   */
  static async selectAIAvatarPreset(
    model: 'gemini' | 'deepseek', 
    presetId: string
  ) {
    const request: SelectAIAvatarRequest = { presetId };
    const response = await apiService.post<any>(`/avatar/ai/${model}/select`, request);
    if (!response.success || !response.data) {
      throw new Error((response as any).message || response.error?.message || 'Failed to select AI avatar preset');
    }
    return response.data;
  }
}
